import { Request } from '~src/httpClient/serverApi/requests/Request';
import {IResult} from '~src/httpClient/serverApi/types/IResponse';

export interface IRotateSiteEncryptionKeyParams {}

export interface IRotateSiteEncryptionKeyResult extends IResult {}

export class RotateSiteEncryptionKeyRequest extends Request<IRotateSiteEncryptionKeyParams, IRotateSiteEncryptionKeyResult> {
  constructor(params: IRotateSiteEncryptionKeyParams) {
    super('rotateSiteEncryptionKey', params);
  }
}